import React from "react";
import { MapPin, CheckCircle2, Target, Navigation } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { LazyMap } from "@/components/LazyMap";

const PISTAS_MAPS_URL = "https://maps.app.goo.gl/W4ccynVqSETWtXQbA";

const ADVANTAGES = [
  "La DGT viene a examinar a NUESTRAS pistas: practicas en el mismo sitio donde te examinas.",
  "En la mayoría de ciudades no es así: el alumno solo pisa la pista de examen el día de la prueba.",
  "Pistas homologadas para motos (A1, A2, A) y cuadriciclo ligero (AML) y profesionales (B96, EB, C, D y EC).",
];

export default function PistasSection() {
  return (
    <section id="pistas" className="section-pad bg-white relative overflow-hidden" data-testid="pistas-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="rounded-[2rem] bg-[var(--faro-blue)] text-white overflow-hidden relative faro-noise">
          <div className="grid grid-cols-1 lg:grid-cols-2">
            <div className="p-8 sm:p-12 relative z-10">
              <Reveal>
                <span className="eyebrow text-[var(--faro-yellow)]">Pistas de maniobras propias</span>
                <h2 className="font-display font-black tracking-tighter text-4xl sm:text-5xl mt-3 leading-tight">
                  Practica donde te vas a examinar.
                </h2>
                <p className="mt-4 text-lg text-white/85">
                  Contamos con pistas de prácticas propias a las que la DGT acude a examinar a nuestros alumnos.
                  Una gran ventaja: llegas al examen conociendo cada metro del circuito.
                </p>
              </Reveal>

              <div className="mt-8 space-y-3">
                {ADVANTAGES.map((a, i) => (
                  <Reveal key={i} delay={i * 0.06}>
                    <div className="flex items-start gap-3">
                      <CheckCircle2 size={20} className="text-[var(--faro-yellow)] mt-0.5 shrink-0" />
                      <p className="text-white/90">{a}</p>
                    </div>
                  </Reveal>
                ))}
              </div>

              <Reveal delay={0.2}>
                <a
                  href={PISTAS_MAPS_URL}
                  target="_blank"
                  rel="noreferrer"
                  data-testid="pistas-maps-link"
                  className="btn-pill mt-8 bg-[var(--faro-yellow)] text-[var(--faro-blue-deep)] hover:brightness-95"
                >
                  <Navigation size={16} /> Ver las pistas y cómo llegar
                </a>
              </Reveal>
            </div>

            <div className="relative min-h-[320px] lg:min-h-full">
              <div className="absolute inset-0">
                <LazyMap
                  src="https://www.google.com/maps?q=42.1864462,-8.6923246&z=17&output=embed"
                  title="Ubicación de las pistas de maniobras"
                  testid="pistas-map"
                  autoLoad
                />
              </div>
              <a
                href={PISTAS_MAPS_URL}
                target="_blank"
                rel="noreferrer"
                data-testid="pistas-map-badge"
                className="absolute top-4 left-4 z-10 inline-flex items-center gap-2 bg-white text-[var(--faro-blue)] px-4 py-2 rounded-full font-bold text-sm shadow-lg hover:brightness-95"
              >
                <MapPin size={15} /> Ubicación de las pistas
              </a>
              <div className="absolute bottom-4 right-4 z-10 inline-flex items-center gap-2 bg-[var(--faro-red)] text-white px-4 py-2 rounded-full font-bold text-xs uppercase tracking-wide shadow-lg">
                <Target size={14} /> Examen DGT aquí
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
